import {Component, Input} from '@angular/core';
import {TypeConfig} from '../../../models/overviewTypeConfig.model';

@Component({
  selector: 'mp-detail-headline',
  templateUrl: './detail-headline.component.html',
  styleUrls: ['./detail-headline.component.css']
})
export class DetailHeadlineComponent {

  @Input() typeConfig: TypeConfig;

}
